export default "__VITE_ASSET__lfNX$FCJ__"